export default __webpack_public_path__ + "static/media/g2022-4.a2c58b20.jpeg";